import {createAction} from '@reduxjs/toolkit'
import {RejectResponseType} from 'types/errorResponse'

export const bookOfferFinalizationError = createAction<RejectResponseType>(
  'bookOffer/bookOfferFinalizationError'
)
